import { gql } from "@apollo/client";

export const HUMAN_RESOURCES_QUERY = gql`
    query HumanResources {
        revenuePerEmployees {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        headcounts {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        triRs {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        timeToFills {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        internalFillRates {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        engagementScores {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }




        headcountByDepartments {
            items {
                currentMonthHeadcount
                currentMonthPercentage
                currentQuarterHeadcount
                currentQuarterPercentage
                currentYearHeadcount
                currentYearPercentage
                departmentName
            }
        }
        retentionRateMixes {
            items {
                category
                currentMonthCount
                currentMonthPercentage
                currentQuarterCount
                currentQuarterPercentage
                currentYearCount
                currentYearPercentage
            }
        }
        tenureMixes {
            items {
                category
                currentMonthCount
                currentMonthPercentage
                currentQuarterCount
                currentQuarterPercentage
                currentYearCount
                currentYearPercentage
            }
        }
        hiringSourceMixes {
            items {
                category
                currentMonthCount
                currentMonthPercentage
                currentQuarterCount
                currentQuarterPercentage
                currentYearCount
                currentYearPercentage
            }
        }
        hiringFunnels {
            items {
                currentMonth
                currentQuarter
                currentYear
                stage
            }
        }
        applicationByRoleSources {
            items {
                channelName
                mtdValue
                qtdValue
                roleName
                ytdValue
            }
        }
        headcountByDepartmentMonthlies {
            items {
                departmentName
                employeeCount
                monthNumber
                yearMonth
                yearNumber
            }
        }








    }
`;

 